// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-wrapper {
	width: 100%;
	background-color: var(--background);
	display: flex;
	justify-content: center;
	padding: 100px 0;
}

.footer {
	width: 100%;
	display: flex;
	gap: 120px;
	padding: 0 20px;
	max-width: 1340px;
}

.footer__logo {
	max-width: 555px;
	width: 100%;
}

.footer__links-block {
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 120px;
	max-width: 475px;
}

.footer__main-links-block {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 40px;
}

.footer__links-column {
	display: flex;
	flex-direction: column;
	gap: 40px;
}

.footer__privacy-block {
	display: flex;
	align-items: center;
	gap: 40px;
}

.footer__project-name {
	font-size: 20px;
	font-family: "Poppins", sans-serif;
	color: var(--dark);
	font-weight: 300;
}

.footer__privacy-link {
	font-size: 20px;
	font-family: "Poppins", sans-serif;
	color: var(--dark);
	font-weight: 300;
}

.footer__links-column-title {
	font-size: 24px;
	font-family: "Poppins", sans-serif;
	line-height: 24px;
	color: var(--dark);
	font-weight: 400;
	text-transform: uppercase;
}

.footer__links-list {
	display: flex;
	flex-direction: column;
}

.footer__link-item {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 20px;
	line-height: 24px;
	letter-spacing: -0.03em;
	color: var(--dark);
	font-weight: 300;
	height: 44px;
	padding: 0 20px;
	border-radius: 30px;
	transition: 0.3s;
	width: fit-content;
}

.footer__link-item:hover {
	color: var(--background);
	background-color: var(--button);
	transition: 0.3s;
}

.footer__link-item:hover img {
	filter: invert(100%) sepia(6%) saturate(0%) hue-rotate(70deg)
		brightness(108%) contrast(108%);
	transition: 0.3s;
}

@media (max-width: 1150px) {
	.footer__logo {
		max-width: unset;
		width: 100%;
	}

	.footer {
		width: 100%;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 80px;
		padding: 0 20px;
		max-width: 1340px;
	}

	.footer__links-column-title {
		font-size: 20px;
		font-family: "Poppins", sans-serif;
		line-height: 24px;
		color: var(--dark);
		font-weight: 400;
		text-transform: uppercase;
	}

	.footer__link-item {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 16px;
		line-height: 20px;
		letter-spacing: -0.03em;
		color: var(--dark);
		font-weight: 300;
		height: 38px;
		padding: 0 16px;
		border-radius: 30px;
		transition: 0.3s;
		width: fit-content;
	}

	.footer__main-links-block {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 32px;
	}

	.footer__links-column {
		display: flex;
		flex-direction: column;
		gap: 32px;
	}

	.footer__privacy-block {
		display: flex;
		align-items: center;
		gap: 32px;
	}

	.footer__links-block {
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 80px;
		max-width: 475px;
	}

	.footer__project-name {
		font-size: 16px;
		font-family: "Poppins", sans-serif;
		color: var(--dark);
		font-weight: 300;
	}

	.footer__privacy-link {
		font-size: 16px;
		font-family: "Poppins", sans-serif;
		color: var(--dark);
		font-weight: 300;
	}
}

@media (max-width: 950px) {
	.footer-wrapper {
		width: 100%;
		background-color: var(--background);
		display: flex;
		justify-content: center;
		padding: 40px 0;
	}

	.footer {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 40px;
		padding: 0 20px;
		max-width: 1340px;
	}

	.footer__logo {
		max-width: 270px;
		width: 100%;
		margin: auto;
	}

	.footer__links-block {
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 40px;
		max-width: 475px;
	}

	.footer__main-links-block {
		display: grid;
		grid-template-columns: 1fr;
		gap: 40px;
	}

	.footer__links-column {
		display: flex;
		flex-direction: column;
		gap: 24px;
	}

	.footer__privacy-block {
		display: flex;
		align-items: center;
		gap: 24px;
	}

	.footer__links-column-title {
		font-size: 18px;
		font-family: "Poppins", sans-serif;
		line-height: 20px;
		color: var(--dark);
		font-weight: 400;
		text-transform: uppercase;
	}

	.footer__link-item {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 16px;
		line-height: 20px;
		letter-spacing: -0.03em;
		color: var(--dark);
		font-weight: 300;
		height: 38px;
		padding: 0 16px;
		border-radius: 20px;
		transition: 0.3s;
		width: fit-content;
	}
}
`, "",{"version":3,"sources":["webpack://./src/app/components/layout/Footer/Footer.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,mCAAmC;CACnC,aAAa;CACb,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,UAAU;CACV,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,iBAAiB;CACjB,uBAAuB;CACvB,kBAAkB;CAClB,gBAAgB;CAChB,YAAY;CACZ,eAAe;CACf,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC;iCACgC;CAChC,gBAAgB;AACjB;;AAEA;CACC;EACC,gBAAgB;EAChB,WAAW;CACZ;;CAEA;EACC,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;CAC1B;;CAEA;EACC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;CACnB;;CAEA;EACC,aAAa;EACb,qCAAqC;EACrC,SAAS;CACV;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,SAAS;CACV;;CAEA;EACC,aAAa;EACb,mBAAmB;EACnB,SAAS;CACV;;CAEA;EACC,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,WAAW;EACX,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;EAChB,WAAW;EACX,YAAY;CACb;;CAEA;EACC,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,0BAA0B;EAC1B,SAAS;CACV;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,SAAS;CACV;;CAEA;EACC,aAAa;EACb,mBAAmB;EACnB,SAAS;CACV;;CAEA;EACC,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;CAC1B;;CAEA;EACC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;CACnB;AACD","sourcesContent":[".footer-wrapper {\n\twidth: 100%;\n\tbackground-color: var(--background);\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding: 100px 0;\n}\n\n.footer {\n\twidth: 100%;\n\tdisplay: flex;\n\tgap: 120px;\n\tpadding: 0 20px;\n\tmax-width: 1340px;\n}\n\n.footer__logo {\n\tmax-width: 555px;\n\twidth: 100%;\n}\n\n.footer__links-block {\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 120px;\n\tmax-width: 475px;\n}\n\n.footer__main-links-block {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, 1fr);\n\tgap: 40px;\n}\n\n.footer__links-column {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 40px;\n}\n\n.footer__privacy-block {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 40px;\n}\n\n.footer__project-name {\n\tfont-size: 20px;\n\tfont-family: \"Poppins\", sans-serif;\n\tcolor: var(--dark);\n\tfont-weight: 300;\n}\n\n.footer__privacy-link {\n\tfont-size: 20px;\n\tfont-family: \"Poppins\", sans-serif;\n\tcolor: var(--dark);\n\tfont-weight: 300;\n}\n\n.footer__links-column-title {\n\tfont-size: 24px;\n\tfont-family: \"Poppins\", sans-serif;\n\tline-height: 24px;\n\tcolor: var(--dark);\n\tfont-weight: 400;\n\ttext-transform: uppercase;\n}\n\n.footer__links-list {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.footer__link-item {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tfont-size: 20px;\n\tline-height: 24px;\n\tletter-spacing: -0.03em;\n\tcolor: var(--dark);\n\tfont-weight: 300;\n\theight: 44px;\n\tpadding: 0 20px;\n\tborder-radius: 30px;\n\ttransition: 0.3s;\n\twidth: fit-content;\n}\n\n.footer__link-item:hover {\n\tcolor: var(--background);\n\tbackground-color: var(--button);\n\ttransition: 0.3s;\n}\n\n.footer__link-item:hover img {\n\tfilter: invert(100%) sepia(6%) saturate(0%) hue-rotate(70deg)\n\t\tbrightness(108%) contrast(108%);\n\ttransition: 0.3s;\n}\n\n@media (max-width: 1150px) {\n\t.footer__logo {\n\t\tmax-width: unset;\n\t\twidth: 100%;\n\t}\n\n\t.footer {\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t\tgap: 80px;\n\t\tpadding: 0 20px;\n\t\tmax-width: 1340px;\n\t}\n\n\t.footer__links-column-title {\n\t\tfont-size: 20px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tline-height: 24px;\n\t\tcolor: var(--dark);\n\t\tfont-weight: 400;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.footer__link-item {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 8px;\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t\tletter-spacing: -0.03em;\n\t\tcolor: var(--dark);\n\t\tfont-weight: 300;\n\t\theight: 38px;\n\t\tpadding: 0 16px;\n\t\tborder-radius: 30px;\n\t\ttransition: 0.3s;\n\t\twidth: fit-content;\n\t}\n\n\t.footer__main-links-block {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t\tgap: 32px;\n\t}\n\n\t.footer__links-column {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 32px;\n\t}\n\n\t.footer__privacy-block {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 32px;\n\t}\n\n\t.footer__links-block {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 80px;\n\t\tmax-width: 475px;\n\t}\n\n\t.footer__project-name {\n\t\tfont-size: 16px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tcolor: var(--dark);\n\t\tfont-weight: 300;\n\t}\n\n\t.footer__privacy-link {\n\t\tfont-size: 16px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tcolor: var(--dark);\n\t\tfont-weight: 300;\n\t}\n}\n\n@media (max-width: 950px) {\n\t.footer-wrapper {\n\t\twidth: 100%;\n\t\tbackground-color: var(--background);\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tpadding: 40px 0;\n\t}\n\n\t.footer {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 40px;\n\t\tpadding: 0 20px;\n\t\tmax-width: 1340px;\n\t}\n\n\t.footer__logo {\n\t\tmax-width: 270px;\n\t\twidth: 100%;\n\t\tmargin: auto;\n\t}\n\n\t.footer__links-block {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 40px;\n\t\tmax-width: 475px;\n\t}\n\n\t.footer__main-links-block {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr;\n\t\tgap: 40px;\n\t}\n\n\t.footer__links-column {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 24px;\n\t}\n\n\t.footer__privacy-block {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 24px;\n\t}\n\n\t.footer__links-column-title {\n\t\tfont-size: 18px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tline-height: 20px;\n\t\tcolor: var(--dark);\n\t\tfont-weight: 400;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.footer__link-item {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 8px;\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t\tletter-spacing: -0.03em;\n\t\tcolor: var(--dark);\n\t\tfont-weight: 300;\n\t\theight: 38px;\n\t\tpadding: 0 16px;\n\t\tborder-radius: 20px;\n\t\ttransition: 0.3s;\n\t\twidth: fit-content;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
